import React, { Component } from "react";
import { Routes } from './routes';
import { withResponsiveMode, ResponsiveMode } from 'office-ui-fabric-react/lib/utilities/decorators/withResponsiveMode';
import { HashRouter as Router } from 'react-router-dom';
import { app } from '@microsoft/teams-js';
import { connect } from 'react-redux'
import { getMSContext } from './actions/index'
import { authorize, getsetting } from './helpers/auth'
import ErrorPage from './containers/ErrorPage/ErrorPage'
import './styles/Global.css'
import './styles/Fluent.css';
import { registerIcons } from '@uifabric/styling';
import { AppSettings } from "./AppSettings";
import * as Storage from './helpers/StorageHelper';

registerIcons({
  icons: {
    'Play': <i className="fluent_play_24_regular"></i>,
    'Video': <i className="fluent_video_24_regular"></i>,
    'Documentation': <i className="fluent_document_one_page_24_regular"></i>,
    'MapLayers': <i className="fluent_lightbulb_20_regular"></i>,
    'HintText': <i className="fluent_important_20_regular"></i>,
    'PostUpdate': <i className="fluent_tasks_app_24_regular"></i>,
  }
});

class App extends Component {
  localContext = { tid: 'Dev', userPrincipalName: 'dev@dev.com', locale: 'en', showBuildMenu: true, role: "admin" }
  adminContext = { tid: window.location.href.split("tid")[1] !== undefined ? window.location.href.split("tid")[1].replace("?", "").replace("=", "") : "", userPrincipalName: '', locale: 'en',showBuildMenu: true, role: "user" }

  isLocalEnv = () => {
    return window.location.origin.indexOf('localhost') > -1
  }
  isAdminEnv = () => {
    return Storage.getItemInSessionStorage(Storage.sessionKeys.Authorize) || window.location.href.indexOf('tid') > -1
  }
  state = {
    contextLoaded: false,
    authorized: true
  }
  authorizeTenant = (tid) => {
    try {
      if (tid) {
        authorize(tid).then(response => {
          this.setState({ authorized: tid === response.tid ? true : false })
          if (tid == response.tid) {
            let adminContext = {
              tid: response.tid,
              userPrincipalName: '',
              locale: 'en',
              role: response.isAdmin ? "admin" : "user",
              showBuildMenu: response.showBuildMenu
            }
            getsetting().then(settings => {
              Storage.setItemInLocalStorage(Storage.sessionKeys.SupportEmail, settings.data);
              this.props.getMSContext(adminContext)
              Storage.setItemInSessionStorage(Storage.sessionKeys.Authorize, true);
              Storage.setItemInSessionStorage(Storage.sessionKeys.Tid, response.tid);
            })
          }
        })
      } else {
        this.setState({
          authorized: false
        });
      }
    } catch (error) {
      this.setState({
        authorized: false
      });
    }
  }
  clearCacheData = () => {
    caches.open('v1').then(function (cache) {
      cache.keys().then(function (keys) {
        keys.forEach(function (request, index, array) {
          cache.delete(request);
        });
      });
    });
    if (caches) {
      caches.keys().then((names) => {
        for (const name of names) {
          caches.delete(name);
        }
      });
    }
    window.location.reload(true);
  };
  componentDidUpdate(prevPros) {
    if (this.props.context && prevPros.context && this.props.context.tid !== prevPros.context.tid) {
      const tid = this.props.context ? this.props.context.tid : null; 
      this.authorizeTenant(tid);
    }
  }
  componentDidMount() {
    const version = Storage.getItemInLocalStorage(Storage.sessionKeys.ProdVersion);
    //let theme = Storage.getItemInLocalStorage(Storage.sessionKeys.Theme);
    if (!version || version !== AppSettings.ProdVersion) {
      this.clearCacheData();
      Storage.setItemInLocalStorage(Storage.sessionKeys.ProdVersion, AppSettings.ProdVersion);
    }
    if (this.isLocalEnv()) {
      this.props.getMSContext(this.localContext)
      this.setState({ contextLoaded: true }, () => {
        const tid = this.props.context ? this.props.context.tid : null;      
        this.authorizeTenant(tid);
        import(`./styles/Themes/default.css`);
        //Storage.setItemInLocalStorage(Storage.sessionKeys.Theme, theme)
      })
    }
    else if (this.isAdminEnv()) {
      if (Storage.getItemInSessionStorage(Storage.sessionKeys.Authorize)) {
        if (this.adminContext.tid == '') {
          this.adminContext.tid = Storage.getItemInSessionStorage(Storage.sessionKeys.Tid);
          this.adminContext.role = Storage.getItemInSessionStorage(Storage.sessionKeys.Authorize) ? "admin" : "user"
        }
      }
      this.props.getMSContext(this.adminContext)
      this.setState({ contextLoaded: true }, () => {
        const tid = this.props.context ? this.props.context.tid : null; 
        this.authorizeTenant(tid);
        import(`./styles/Themes/default.css`);
        //Storage.setItemInLocalStorage(Storage.sessionKeys.Theme, theme)
        window.history.pushState(null, "", window.location.href.split("tid")[0].replace("?", ""));
      })
    } else {
      app.initialize(["https://teams.microsoftonline.cn"]);
      const themeChanged = function (theme) {
        import(`./styles/Themes/${theme}.css`);
        //Storage.setItemInLocalStorage(Storage.sessionKeys.Theme, theme)
      };
      app.registerOnThemeChangeHandler(themeChanged);
      app.getContext().then((context) => {
        this.props.getMSContext(context);
        this.setState({ contextLoaded: true }, () => {
          this.authorizeTenant(context.user.tenant.id);
          const theme = context.app.theme;
          import(`./styles/Themes/${theme}.css`);
          //Storage.setItemInLocalStorage(Storage.sessionKeys.Theme, theme)
        })
      })
    }
  }
  render() {
    const { responsiveMode } = this.props;
    const { contextLoaded, authorized } = this.state;
    const isSmallDevice = responsiveMode < ResponsiveMode.xLarge;
    return contextLoaded ? authorized ?
      <Router basename={this.props.basename} history={this.props.history} hashType="noslash">
        <Routes authorized={authorized} isSmallDevice={isSmallDevice} />
      </Router> : <ErrorPage code={403} message="Access Denied" isSmallDevice={isSmallDevice} /> : <p></p>
  }
}

const mapStateToProps = state => ({
  context: state.app.context
})
const mapDispatchToProps = dispatch => ({
  getMSContext: (context) => dispatch(getMSContext(context))
})

export default withResponsiveMode(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(App),
);